function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2000(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20.19,
    height: 7.7,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.9625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 3.85,
    fontFamily: "Arial"
  }, "\n        Keweenaw\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 7.7,
    width: 20.19,
    height: 14.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.635
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 14.969999999999999,
    fontFamily: "Arial"
  }, "\n        Luce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22.24,
    width: 20.19,
    height: 19.45,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2416666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 31.964999999999996,
    fontFamily: "Arial"
  }, "\n        Baraga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 41.69,
    width: 20.19,
    height: 22.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.365
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 53.135,
    fontFamily: "Arial"
  }, "\n        Oscoda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 64.58,
    width: 20.19,
    height: 23.8,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2433333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 76.48,
    fontFamily: "Arial"
  }, "\n        Ontonagon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 88.38,
    width: 20.19,
    height: 24.07,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8354545454545457
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 100.41499999999999,
    fontFamily: "Arial"
  }, "\n        Schoolcraft\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 112.45,
    width: 20.19,
    height: 25.03,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.038
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 124.965,
    fontFamily: "Arial"
  }, "\n        Alger\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 137.49,
    width: 20.19,
    height: 26.91,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 150.94500000000002,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 164.39,
    width: 20.19,
    height: 28.72,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8354545454545457
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 178.75,
    fontFamily: "Arial"
  }, "\n        Montmorency\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 193.11,
    width: 20.19,
    height: 34.23,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.52375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 210.22500000000002,
    fontFamily: "Arial"
  }, "\n        Mackinac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 227.34,
    width: 20.19,
    height: 34.38,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.365
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 244.53,
    fontFamily: "Arial"
  }, "\n        Alcona\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 261.73,
    width: 20.19,
    height: 35.48,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 279.47,
    fontFamily: "Arial"
  }, "\n        Iron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 297.21,
    width: 20.19,
    height: 36.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.52375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 315.455,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 333.69,
    width: 20.19,
    height: 37.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2433333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 352.315,
    fontFamily: "Arial"
  }, "\n        Missaukee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 370.94,
    width: 20.19,
    height: 39.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.52375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 390.575,
    fontFamily: "Arial"
  }, "\n        Kalkaska\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 410.21,
    width: 20.19,
    height: 40.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 430.505,
    fontFamily: "Arial"
  }, "\n        Presque_Isle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 450.8,
    width: 20.19,
    height: 41.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.365
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 471.635,
    fontFamily: "Arial"
  }, "\n        Arenac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 492.47,
    width: 20.19,
    height: 46.28,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.365
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 515.61,
    fontFamily: "Arial"
  }, "\n        Benzie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 538.75,
    width: 20.19,
    height: 47.81,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8842857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 562.655,
    fontFamily: "Arial"
  }, "\n        Gogebic\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 586.56,
    width: 20.19,
    height: 56.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.365
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 614.81,
    fontFamily: "Arial"
  }, "\n        Ogemaw\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 643.07,
    width: 20.19,
    height: 56.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8842857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.095,
    y: 671.5350000000001,
    fontFamily: "Arial"
  }, "\n        Osceola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 0,
    width: 31.71,
    height: 38.09,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5233333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.045,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Menominee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.9,
    y: 0,
    width: 31.93,
    height: 38.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.321666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 67.865,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.83,
    y: 0,
    width: 32.74,
    height: 38.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.456666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 100.2,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Oceana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.57,
    y: 0,
    width: 34.73,
    height: 38.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.34125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 133.935,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Manistee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.3,
    y: 0,
    width: 34.97,
    height: 38.09,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.828333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 168.78500000000003,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Antrim\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.27,
    y: 0,
    width: 35.34,
    height: 38.09,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.048571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 203.94,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Gladwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.62,
    y: 0,
    width: 36.5,
    height: 38.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.5625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.87,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Leelanau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 258.12,
    y: 0,
    width: 37.95,
    height: 38.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7950000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 277.095,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Charlevoix\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.07,
    y: 0,
    width: 38.32,
    height: 38.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.618
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.23,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Clare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.38,
    y: 0,
    width: 38.35,
    height: 38.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.232222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 353.555,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Cheboygan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.73,
    y: 0,
    width: 39,
    height: 38.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.232222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 392.23,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Dickinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.73,
    y: 0,
    width: 39.29,
    height: 38.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.232222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 431.375,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Roscommon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451.02,
    y: 0,
    width: 39.46,
    height: 38.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.441428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 470.75,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Wexford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490.47,
    y: 0,
    width: 39.56,
    height: 38.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.618
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 510.25,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Mason\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530.03,
    y: 0,
    width: 40.18,
    height: 38.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.618
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.12,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Iosco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 570.22,
    y: 0,
    width: 42.95,
    height: 38.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.348333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 591.695,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Alpena\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 613.17,
    y: 0,
    width: 43.21,
    height: 38.09,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.76125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 634.775,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Houghton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 656.37,
    y: 0,
    width: 43.63,
    height: 38.09,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.76125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 678.1850000000001,
    y: 19.045,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 38.09,
    width: 45.34,
    height: 37.56,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.5120000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.86,
    y: 56.870000000000005,
    fontFamily: "Arial"
  }, "\n        Emmet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 75.66,
    width: 45.34,
    height: 37.67,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.381428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.86,
    y: 94.495,
    fontFamily: "Arial"
  }, "\n        Mecosta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 113.33,
    width: 45.34,
    height: 38.76,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5371428571428565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.86,
    y: 132.71,
    fontFamily: "Arial"
  }, "\n        Gratiot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 152.09,
    width: 45.34,
    height: 40.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.716666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.86,
    y: 172.24,
    fontFamily: "Arial"
  }, "\n        Branch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 192.39,
    width: 45.34,
    height: 41.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.22
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.86,
    y: 212.94,
    fontFamily: "Arial"
  }, "\n        Huron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 233.48,
    width: 45.34,
    height: 44.21,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.842
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.86,
    y: 255.58499999999998,
    fontFamily: "Arial"
  }, "\n        Delta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 277.7,
    width: 45.34,
    height: 44.62,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.957777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.86,
    y: 300.01,
    fontFamily: "Arial"
  }, "\n        Hillsdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 322.31,
    width: 45.34,
    height: 47.41,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.477142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.86,
    y: 346.015,
    fontFamily: "Arial"
  }, "\n        Sanilac\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 369.72,
    width: 45.34,
    height: 49.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.477142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.86,
    y: 394.69000000000005,
    fontFamily: "Arial"
  }, "\n        Newaygo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 419.66,
    width: 45.34,
    height: 50.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.86,
    y: 444.97,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 470.28,
    width: 45.34,
    height: 53.8,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.6675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.86,
    y: 497.17999999999995,
    fontFamily: "Arial"
  }, "\n        Isabella\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 524.08,
    width: 45.34,
    height: 56.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.534000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.86,
    y: 552.2,
    fontFamily: "Arial"
  }, "\n        St._Joseph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 580.31,
    width: 45.34,
    height: 58.48,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.6675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.86,
    y: 609.55,
    fontFamily: "Arial"
  }, "\n        Montcalm\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.19,
    y: 638.79,
    width: 45.34,
    height: 61.21,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.068000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 42.86,
    y: 669.395,
    fontFamily: "Arial"
  }, "\n        Ionia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.53,
    y: 38.09,
    width: 47.63,
    height: 59.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.804285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 89.345,
    y: 68.055,
    fontFamily: "Arial"
  }, "\n        Tuscola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.16,
    y: 38.09,
    width: 50.7,
    height: 59.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.51,
    y: 68.055,
    fontFamily: "Arial"
  }, "\n        Barry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.86,
    y: 38.09,
    width: 56.37,
    height: 59.93,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.263333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.04500000000002,
    y: 68.055,
    fontFamily: "Arial"
  }, "\n        Marquette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.23,
    y: 38.09,
    width: 56.96,
    height: 59.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.328888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.70999999999998,
    y: 68.055,
    fontFamily: "Arial"
  }, "\n        Van_Buren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.18,
    y: 38.09,
    width: 62.21,
    height: 59.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.561428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.285,
    y: 68.055,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.39,
    y: 38.09,
    width: 62.24,
    height: 59.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.993
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.51,
    y: 68.055,
    fontFamily: "Arial"
  }, "\n        Shiawassee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.63,
    y: 38.09,
    width: 71.93,
    height: 59.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.988333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 437.595,
    y: 68.055,
    fontFamily: "Arial"
  }, "\n        Lapeer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.56,
    y: 38.09,
    width: 73.85,
    height: 59.93,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.280714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 510.485,
    y: 68.055,
    fontFamily: "Arial"
  }, "\n        Grand_Traverse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.42,
    y: 38.09,
    width: 75.13,
    height: 59.93,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.561428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 584.9849999999999,
    y: 68.055,
    fontFamily: "Arial"
  }, "\n        Midland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 622.54,
    y: 38.09,
    width: 77.46,
    height: 59.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.561428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 661.27,
    y: 68.055,
    fontFamily: "Arial"
  }, "\n        Lenawee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.53,
    y: 98.02,
    width: 74.98,
    height: 69.32,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.902857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.02000000000001,
    y: 132.68,
    fontFamily: "Arial"
  }, "\n        Allegan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.53,
    y: 167.33,
    width: 74.98,
    height: 76.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.02000000000001,
    y: 205.37,
    fontFamily: "Arial"
  }, "\n        Eaton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.53,
    y: 243.41,
    width: 74.98,
    height: 79.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.993333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.02000000000001,
    y: 283.275,
    fontFamily: "Arial"
  }, "\n        Bay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.53,
    y: 323.15,
    width: 74.98,
    height: 85.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.711428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.02000000000001,
    y: 365.67499999999995,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.53,
    y: 408.19,
    width: 74.98,
    height: 95.42,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.496666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.02000000000001,
    y: 455.9,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.53,
    y: 503.61,
    width: 74.98,
    height: 95.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.711428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.02000000000001,
    y: 551.4350000000001,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.53,
    y: 599.26,
    width: 74.98,
    height: 100.74,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.711428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.02000000000001,
    y: 649.63,
    fontFamily: "Arial"
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.51,
    y: 98.02,
    width: 73.97,
    height: 107.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.21888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.495,
    y: 151.64,
    fontFamily: "Arial"
  }, "\n        St._Clair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.47,
    y: 98.02,
    width: 74.78,
    height: 107.24,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.3475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.86,
    y: 151.64,
    fontFamily: "Arial"
  }, "\n        Muskegon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.25,
    y: 98.02,
    width: 81.48,
    height: 107.24,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.148
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.99,
    y: 151.64,
    fontFamily: "Arial"
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370.73,
    y: 98.02,
    width: 101.21,
    height: 107.24,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.458571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 421.33500000000004,
    y: 151.64,
    fontFamily: "Arial"
  }, "\n        Saginaw\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471.94,
    y: 98.02,
    width: 108.66,
    height: 107.24,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.915555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.27,
    y: 151.64,
    fontFamily: "Arial"
  }, "\n        Kalamazoo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 580.6,
    y: 98.02,
    width: 119.4,
    height: 107.24,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.87333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.3000000000001,
    y: 151.64,
    fontFamily: "Arial"
  }, "\n        Ottawa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.51,
    y: 205.26,
    width: 106.8,
    height: 130.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.91,
    y: 270.625,
    fontFamily: "Arial"
  }, "\n        Ingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.51,
    y: 335.99,
    width: 106.8,
    height: 157.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.866666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.91,
    y: 414.55,
    fontFamily: "Arial"
  }, "\n        Washtenaw\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.51,
    y: 493.1,
    width: 106.8,
    height: 206.9,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.257142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.91,
    y: 596.5500000000001,
    fontFamily: "Arial"
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.31,
    y: 205.26,
    width: 190.17,
    height: 152.39,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 38.0975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.395,
    y: 281.455,
    fontFamily: "Arial"
  }, "\n        Kent\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 437.48,
    y: 205.26,
    width: 262.52,
    height: 152.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.39833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 568.74,
    y: 281.455,
    fontFamily: "Arial"
  }, "\n        Macomb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.31,
    y: 357.65,
    width: 192.84,
    height: 342.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.548571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 343.73,
    y: 528.825,
    fontFamily: "Arial"
  }, "\n        Oakland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.15,
    y: 357.65,
    width: 259.85,
    height: 342.35,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 51.970000000000006
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 570.075,
    y: 528.825,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2000);
export default __webpack_public_path__ + "static/media/2000.e0d7c9eeaf7c044ddf19d293fea49a7f.svg";
export { ForwardRef as ReactComponent };